export default __webpack_public_path__ + "static/all-fine-girl-14fb2d1462664788295d739c9ae0fb9a.png";